import { create } from "zustand";
import axios from "../helper/axios";

const useGroupStore = create((set, get) => ({
    isModalOpenG: false,
    currentGroups:null,
    groupUpdateFlag: false,

    setModalOpenG: () => {
        set({ isModalOpenG: true });
    },
    handleModalGOk: () => {
        set({ isModalOpenG: false });
    },
    handleModalGCancel: () => {
        set({ isModalOpenG: false });
    },
    handleGroupAdd: async (value) => {
        try {
            console.log("Set New Project",value)
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/addGroup/${userData.qhoid}/${userData.qhuid}/${userData.username}/${value}`
            );
            set({ groupUpdateFlag: true }); 
        } catch (err) {
            console.log(err);
        }
    },
    removeGroup: async (value) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/removeGroup/${userData.qhoid}/${userData.qhuid}/${userData.username}/${value}`
            );
            set({ groupUpdateFlag: true }); 
        } catch (err) {
            console.error(err);
        }
    },
    resetGroupUpdate: () => {
        set({ groupUpdateFlag: false });
    },

}));

export default useGroupStore;
